import Auth from 'pages/auth/'
/* const Auth = lazy(() => import('pages/auth/')) */

const AuthRoutes = {
  path: '/auth',
  element: <Auth />,
}

export default AuthRoutes
